import React from "react";
import { Dialog, DialogContent, DialogTitle, FormControlLabel, Grid, Switch, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
import { SubmittableForm } from "components/form/SubmittableForm";

type EditSelfServiceDialogProps = {
  open: boolean;
  subscriptionName: string;
  currentValue: boolean;
  handleClose: () => void;
  submitChange: (selfServiceEnabled: boolean) => Promise<void>;
};

type SelfServiceFormValues = {
  selfServiceEnabled: boolean;
};

export function EditSelfServiceDialog(props: EditSelfServiceDialogProps) {
  const handleSubmit = async ({ selfServiceEnabled }: SelfServiceFormValues) => {
    await props.submitChange(selfServiceEnabled);
    props.handleClose();
  };

  return (
    <Dialog open={props.open} onClose={props.handleClose}>
      <DialogTitle>Edit Self-Service</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} rowSpacing={2}>
          <Grid size={12}>
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
              }}
            >
              Subscription: <strong>{props.subscriptionName}</strong>
            </Typography>
          </Grid>
          <Grid size={12}>
            <i>
              With self-service off, the owner cannot buy or renew this subscription through the customer portal. Switch
              it off for subscriptions that must go through a sales representative, for example known resellers.
            </i>
          </Grid>
          <Grid size={12}>
            <SubmittableForm submitAction={handleSubmit} onCancel={props.handleClose}>
              {(formController) => {
                const { control } = formController;

                return (
                  <Grid container spacing={3}>
                    <Grid
                      size={{
                        sm: 12,
                      }}
                    >
                      <Controller
                        name="selfServiceEnabled"
                        control={control}
                        defaultValue={props.currentValue}
                        render={({ field }) => (
                          <FormControlLabel
                            control={
                              <Switch onChange={(e) => field.onChange(e.target.checked)} checked={field.value} />
                            }
                            label={"Self-service enabled"}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                );
              }}
            </SubmittableForm>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
